import {DreamEmployerClass, DreamEmployerJSON, DreamEmployerLegacyClass} from '../types/DreamEmployerTypes';

import {ComparisonCardQuestion} from '../../../../../types/shared-types';

export default class DreamEmployerSerializers {
  static toObject(payload: DreamEmployerJSON): DreamEmployerClass | DreamEmployerLegacyClass {
    if (payload.dream_employer_results !== undefined) {
      // Serialize as DreamEmployerClass
      return {
        type: 'dream_employer',
        headline: {
          en: payload.dream_employer_results.headline.en,
          de: payload.dream_employer_results.headline.de,
        },
        text: {
          en: payload.dream_employer_results.text.en,
          de: payload.dream_employer_results.text.de,
        },
        questions: payload.dream_employer_results.questions.map((question) => ({
          title: {
            en: question.title.en,
            de: question.title.de,
          },
          leftOption: {
            en: question.left_option.en,
            de: question.left_option.de,
          },
          rightOption: {
            en: question.right_option.en,
            de: question.right_option.de,
          },
          agreementResults: {
            low: {
              totalAgreement: question.agreement_results.low.total_agreement,
            },
            mid: {
              totalAgreement: question.agreement_results.mid.total_agreement,
            },
            high: {
              totalAgreement: question.agreement_results.high.total_agreement,
            },
          },
        })),
      };
    } else if (payload.dream_employer_legacy_results !== undefined) {
      // Serialize as DreamEmployerLegacyClass
      return {
        type: 'dream_employer_legacy',
        totalScore: payload.dream_employer_legacy_results.total_score,
        questions: payload.dream_employer_legacy_results.questions.map(
          (question): ComparisonCardQuestion => ({
            methodItem: {
              title: {
                en: question.method_item.title.en,
                de: question.method_item.title.de,
              },
              scaleConfiguration: {
                labelLeft: {
                  en: question.method_item.scale_configuration.label_left.en,
                  de: question.method_item.scale_configuration.label_left.de,
                },
                labelRight: {
                  en: question.method_item.scale_configuration.label_right.en,
                  de: question.method_item.scale_configuration.label_right.de,
                },
              },
            },
            results: {
              valueEmployees: question.results.value_employees,
              valueManagement: question.results.value_management,
              valueDreamEmployer: question.results.value_dream_employer,
              overlap: question.results.overlap,
            },
          })
        ),
      };
    } else {
      throw new Error('Invalid payload: Unable to determine the type of DreamEmployer data.');
    }
  }
}
